import { Component, h, Prop, State, Event, EventEmitter, Element} from '@stencil/core';
import '../../stories/Components/ChatTile/ChatTile';
import { formatUnixTimestamp } from '../../utils/unixTimeConverter';
import '../../stories/Components/Loader/Spinner/Spinner'
import '../../stories/Components/ChatSidebar/ContextMenu.js';
import { drawerDialogService } from '../../stories/Components/Dialog-Drawer/dialog-drawer.js';

@Component({
  tag: 'group-cast',
  shadow: false,
  styles: `
    :host {
      display: block;
      height: 100%;
      background: var(--bg-primary-color);
      color: var(--text-primary-color);
    }
    .group-cast-container {
      padding: 20px 0 20px 20px;
      height: 96%;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    .group-cast-header {
      font-size: 24px;
      font-weight: 600;
      padding: 0 20px 0 0;
    }
    .group-cast-body {
      height: 100%;
      max-height: 90%;
      overflow: hidden auto;
      padding: 0 15px 0 0;
    }
    .group-cast-body::-webkit-scrollbar {
      width: 5px;
    }

    .group-cast-body::-webkit-scrollbar-track {
      background: transparent;
    }
    .group-cast-body::-webkit-scrollbar-thumb {
      background-color: var(--bg-secondary-color) !important;
      border-radius: 10px;
    }
        chat-tile:hover {
      background-color: var(--bg-secondary-color) !important;
    }
  `,
})
export class GroupCast {
  @Prop() groupCastData: any[] = [];
  @State() selectedGroupcastId: string = null;
  @Event() groupcastTileSelected: EventEmitter;
  @Event() groupcastScrolledToBottom: EventEmitter;
  @Prop() isLoadingMore: boolean;
  @State() contextMenuX: number= 0;
  @State() contextMenuY: number = 0;
  @State() isContextMenuOpen: boolean = false;
  @State() selectedTileForMenu: any;
  @Element() element: HTMLElement;


  async componentDidLoad() {
    document.addEventListener('menu-item-selected', this.handleMenuItemSelected)
  }

  disconnectedCallback() {
    document.removeEventListener('menu-item-selected', this.handleMenuItemSelected)
  }
  handleScroll =(event: UIEvent) => {
    const target = event.target as HTMLElement;
    const isBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 100;
    if(isBottom) {
      this.groupcastScrolledToBottom.emit();
    }
  }

  getGroupcastIdFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('groupcast');
  }

  isTileSelected(tileGroupcastId: string) {
    const urlGroupcastId = this.getGroupcastIdFromURL();
    return tileGroupcastId === urlGroupcastId;
  }

  handleGroupcastTileSelected(groupcast: any) {
    const selectedGroupcastId = groupcast.groupcastId;
    
    // Update selected state
    this.selectedGroupcastId = selectedGroupcastId;
    
    // Update URL if needed
    const url = new URL(window.location.href);
    url.search = ''
    url.searchParams.set('groupcast', selectedGroupcastId);
    window.history.pushState({}, '', url);

    // Emit event for parent components
    this.groupcastTileSelected.emit({ groupcastId: selectedGroupcastId});
    
    // Call the provided callback
   
    
  }

  handleRightClick(e, tile) {
      e.preventDefault();
      this.contextMenuX = e.clientX;
      this.contextMenuY = e.clientY;
      this.isContextMenuOpen = true;
      this.selectedTileForMenu = tile;
  }
//   handleMenuItemSelected = (e) => {
//     const { action } = e.detail;
//     alert('hello14')
//     switch (action) {
//       case 'delete':
//         // Dispatch a custom event for groupcast deletion
//         const customEvent = new CustomEvent('delete-groupcast', {
//           detail: {
//             groupcastId: (this.selectedTileForMenu)?.groupcastId,
//           },
//           bubbles: true,
//           composed: true
//         });
//         this.element.dispatchEvent(customEvent);
//         break;
//     }
//     this.handleMenuClosed();
// }

handleMenuItemSelected = (e) => {
  const { action } = e.detail;
  console.log(e, '🚀✅')
  switch (action) {
    case 'delete':
      const groupcastId = this.selectedTileForMenu?.groupcastId;
      drawerDialogService.openDialog('confirm-dialog', {
        title: 'Delete Groupcast',
        description: "Are you sure you want to delete this groupcast? This action can't be undone",
        handleConfirm: () => {
          const customEvent = new CustomEvent('delete-groupcast', {
            detail: {
              groupcastId: groupcastId,
            },
            bubbles: true,
            composed: true
          });
          this.element.dispatchEvent(customEvent);
          drawerDialogService.closeDialog('confirm-dialog')
        }
      });
      break;
  }
  this.handleMenuClosed();
}
   
  handleMenuClosed = () => {
      this.isContextMenuOpen = false;
      this.selectedTileForMenu  = null;
  }
  render() {
    return (
      <div class="group-cast-container">
        <div class="group-cast-header">
          <message-search-bar
            label="Groupcast Chats"
            labelColor="var(--text-primary-color)"
            labelFontFamily="sans-serif"
            labelFontWeight="600"
            labelFontSize="var(--title-font-size)"
            labelFontStyle="normal"
            isSearchBarIcons={false}
            borderRadius="10px"
            borderWidth="1px"
            borderColor="var(--text-primary-color)"
            padding="0px"
            margin="0px"
            width="100%"
            inputBgColor="var(--bg-secondary-color)"
            inputFontColor="var(--text-primary-color)"
            inputPlaceholder="Search Chats"
            inputPlaceholderColor="var(--text-primary-color)"
            isSearchBar={true}
          />
        </div>

        <div class="group-cast-body" onScroll={this.handleScroll} >
          {this.groupCastData ? (
            this.groupCastData.length > 0 ? (
              this.groupCastData.map((groupcast, index) => {
                const formattedMessageDate = formatUnixTimestamp(groupcast?.createdAt);
                const isSelected = this.isTileSelected(groupcast?.groupcastId)
                return (
                  <chat-tile
                    key={index}
                    isSelected={isSelected}
                    sidebarSelectedColor={'var(--bg-primary-light)'}
                    onClick={() => this.handleGroupcastTileSelected(groupcast)}
                    onContextmenu={(e) => this.handleRightClick(e, groupcast)}
                    imageSrc={groupcast?.groupcastImageUrl}
                    imageAlt={groupcast?.groupcastTitle}
                    imageHeight="50px"
                    imageWidth="50px"
                    imageRadius="50%"
                    username={groupcast?.groupcastTitle || `RECIPIENTS: ${groupcast?.membersCount}`}
                    usernameFontWeight="600"
                    userNameColor="var(--text-primary-color)"
                    userNameFontSize="16px"
                    chatPreview={groupcast?.metaData?.description}
                    chatPreviewFontSize="14px"
                    messageDate={formattedMessageDate}
                    padding="10px"
                    usernamePadding="1px"
                    height="fit-content"
                    width="100%"
                    messageDateColor="var(--text-last-seen) "
                    messageDateFontWeight="normal"
                    messageDateFontSize="12px"
                    messageDateFontStyle="italic"
                    borderWidth="0 0 0.5px 0"
                    borderColor="var(--bg-secondary-color)"
                    borderStyle="solid"
                  />
                );
              })
            ) : (
              <div style={{ 
                textAlign: 'center', 
                padding: '20px',
                color: 'var(--text-tertiary-color)'
              }}>
                No groupcast chats available
              </div>
            )
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '20px',
              color: 'var(--text-tertiary-color)'
            }}>
              Unable to load groupcast chats
            </div>
          )}
           {this.isLoadingMore && (
            <div style={{ 
              textAlign: 'center', 
              padding: '10px',
              color: 'var(--text-tertiary-color)'
            }}>
              Loading more chats...
            </div>
          )}
       
       {this.isContextMenuOpen
              ? 
                  <context-menu
                    x={this.contextMenuX}
                    y={this.contextMenuY}
                    isOpen={this.isContextMenuOpen}
                    menuItems={[
                      {
                        label: 'Delete Groupcast',
                        action: 'delete',
                        type: 'danger',
                      },
                    ]}
                    onMenuItemSelected={(e) => this.handleMenuItemSelected(e)}
                    onMenuClosed={() => this.handleMenuClosed()}
                  />
                
           : null   }
          
        </div>
      </div>
    );
  }
}
